import React from 'react';

const getLink = (data, value) => {
  const item = data.find(i => i.name === value);
  return item ? item.labelLink : ''; 
}

const CustomizedAxisTick = (props) => {
  const { data, x, y, payload: { value } } = props;
  const imageUrl = getLink(data, value);

  return (
    <g transform={`translate(${x},${y})`}>
      <image
        x="-11"
        y="-5"
        width="20"
        height="20"
        xlinkHref={imageUrl}
      />
      <text
        x="0"
        y="20"
        dy={16}
        textAnchor="middle"
        fill="#666"
        fontSize="0.75rem"
      >
        {value}
      </text>
    </g>
  );
};


export default CustomizedAxisTick;
